/**
 * @description client getters
 */

export default {
  client (state) {
    return state.client
  },
  user (state) {
    return state.user
  }
}
